(() => {
  'use strict';

  const source = 'https://code.tidio.co/iwxssktmakqaxkipszmydpaftv6ottbv.js';
  const sourceFragment = 'code.tidio.co/iwxssktmakqaxkipszmydpaftv6ottbv.js';
  const intentDelay = 1200;
  const fallbackDelay = 15000;
  const intentEvents = ['pointerdown', 'touchstart', 'keydown'];
  let started = false;
  let intentTimer = 0;
  let fallbackTimer = 0;

  const setState = (state, reason = '') => {
    document.documentElement.dataset.avTidioState = state;
    if (reason) document.documentElement.dataset.avTidioReason = reason;
  };

  const emit = (name, reason) => {
    document.dispatchEvent(new CustomEvent(`australia:tidio_${name}`, {
      detail: { reason }
    }));
  };

  const existingScript = () => [...document.scripts]
    .find((script) => script.src.includes(sourceFragment));

  const clearIntentListeners = () => {
    intentEvents.forEach((name) => {
      document.removeEventListener(name, handleIntent, true);
    });
  };

  const load = (reason = 'fallback') => {
    if (started) return;
    const existing = existingScript();
    if (existing || window.tidioChatApi) {
      started = true;
      clearIntentListeners();
      setState('native', reason);
      return;
    }

    started = true;
    clearIntentListeners();
    window.clearTimeout(intentTimer);
    window.clearTimeout(fallbackTimer);
    setState('loading', reason);
    emit('loading', reason);

    const script = document.createElement('script');
    script.id = 'av-deferred-tidio';
    script.src = source;
    script.async = true;
    script.dataset.avDeferredIntegration = 'tidio';
    script.addEventListener('load', () => {
      setState('ready', reason);
      emit('ready', reason);
    }, { once: true });
    script.addEventListener('error', () => {
      started = false;
      script.remove();
      setState('error', reason);
      emit('error', reason);
    }, { once: true });
    document.head.appendChild(script);
  };

  const loadWhenVisible = (reason) => {
    if (!document.hidden) {
      load(reason);
      return;
    }
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) load(reason);
    }, { once: true });
  };

  function handleIntent() {
    if (started || intentTimer) return;
    intentTimer = window.setTimeout(() => loadWhenVisible('intent'), intentDelay);
  }

  const scheduleFallback = () => {
    fallbackTimer = window.setTimeout(() => loadWhenVisible('fallback'), fallbackDelay);
  };

  if (existingScript() || window.tidioChatApi) {
    started = true;
    setState('native', 'existing');
    return;
  }

  setState('waiting');
  intentEvents.forEach((name) => {
    document.addEventListener(name, handleIntent, { capture: true, passive: true });
  });
  document.addEventListener('australia:load-chat', (event) => {
    loadWhenVisible(event.detail?.reason || 'explicit');
  });
  if (document.readyState === 'complete') scheduleFallback();
  else window.addEventListener('load', scheduleFallback, { once: true });
})();
